/**
 * 后台导航分组只负责展示层级，不参与页面鉴权。
 * 组是否显示由组内现有路由的访问权限与模块显隐状态共同决定。
 */
export const ADMIN_NAVIGATION_GROUPS = Object.freeze([
  {
    key: 'system',
    title: '系统运维',
    icon: 'iconfont icon-banshou_Line'
  },
  {
    key: 'aviation',
    title: '飞行管理',
    icon: 'iconfont icon-feiji'
  },
  {
    key: 'commerce',
    title: '运营管理',
    icon: 'iconfont icon-icon-xiaoshoue'
  },
  {
    key: 'content',
    title: '消息管理',
    icon: 'iconfont icon-tongzhi'
  },
  {
    key: 'access',
    title: '账户与权限',
    icon: 'iconfont icon-guanliyuan'
  }
])

/** 将已完成权限过滤的模块路由按稳定分组键组织成导航树。 */
export function buildAdminNavigationGroups (moduleRoutes = []) {
  const routesByGroup = moduleRoutes.reduce((result, route) => {
    const groupKey = route.meta && route.meta.adminNavigationGroup
    if (!groupKey) return result
    if (!result[groupKey]) result[groupKey] = []
    result[groupKey].push(route)
    return result
  }, {})

  return ADMIN_NAVIGATION_GROUPS
    .map(group => ({
      path: `admin-navigation:${group.key}`,
      meta: {
        title: group.title,
        icon: group.icon,
        navigationGroup: true
      },
      children: routesByGroup[group.key] || []
    }))
    .filter(group => group.children.length > 0)
}
